import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'

const styles = theme => ({
  paper: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    borderRadius: '60%',
    margin: 5
  }
})

const PaperIcon = ({ classes, children }) => (
  <Paper className={classes.paper}>{children}</Paper>
)

export default withStyles(styles)(PaperIcon)



// WEBPACK FOOTER //
// ./src/components/PaperIcon.js